module.exports = __webpack_public_path__ + "img/b_head_portrait_woman@2x.9a835f5d.png";